import { IconPropsType } from '..';

export const PlatformFeaturesIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="12"
    height="18"
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.49996 5.88109L9.07105 9.21436L6.07814 7.64018L3.08523 9.21436L3.65632 5.88109L1.23451 3.51982L4.58087 3.02891L6.07814 0L7.57542 3.03382L10.9218 3.52473L8.49996 5.88109ZM11.4896 8.91V11.9929L6.10923 14.1791L6.07814 14.166L0.666687 11.9945V8.91L6.07814 11.0815L11.4896 8.91ZM11.4896 12.7325V15.8138L6.10923 18L6.07814 17.9869L0.666687 15.8155V12.7325L6.07814 14.904L11.4896 12.7325Z"
      fill="#EFEFEF"
    />
  </svg>
);
